import {defineStyle, defineStyleConfig} from '@chakra-ui/react';
import { colorByMode } from 'theme/themeHelper';

const baseStyle = defineStyle((props) => {
    return {
        color: colorByMode('text', props.colorMode),
    };
});

const title = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'lg',
        fontWeight: '600',
        color: colorByMode('title', colorMode),
    };
});

const subTitle = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'md',
        fontWeight: '600',
        color: colorByMode('title', colorMode),
    };
});

const cardTitle = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'sm',
        fontWeight: '500',
        color: colorByMode('title', colorMode),
    };
});

const cardText = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'xs',
        fontWeight: '600',
    };
});

const normal = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'xs',
        fontWeight: '500',
    };
});

const normalBold = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'xs',
        fontWeight: '600',
    };
});

const content = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'xs',
        fontWeight: '400',
        lineHeight: '1.2',
    };
});

const helperTitle = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: 'xs',
        fontWeight: '500',
        lineHeight: '1.2',
    };
});

const helper = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: '2xs',
        fontWeight: '500',
        lineHeight: '1.2',
        color: colorByMode('gray', colorMode),
    };
});

const caption = defineStyle((props) => {
    const {colorScheme: c, colorMode} = props;
    return {
        fontSize: '2xs',
        fontWeight: '500',
        lineHeight: '1.2',
        color: colorByMode('gray', colorMode),
    };
});

const textTheme = defineStyleConfig({
    baseStyle,
    variants: {
        title,
        subTitle,
        normal,
        content,
        helper,
        caption,
        helperTitle,
        normalBold,
        cardTitle,
        cardText,
    },
    defaultProps: {
        variant: 'normal',
    },
});

export default textTheme;
